import type { PaletteMode } from '@mui/material/styles';
import { resolveThemeColors, type CustomTheme, type ThemeColors } from '@/theme';

/**
 * The colours the user wore last, kept in localStorage so a reload wears them before the
 * preferences and the tenant's colours have come back from the API — no flash of navy.
 */
const ACCENT_CACHE_KEY = 'nexo.theme.accent';
const CUSTOM_THEME_CACHE_KEY = 'nexo.theme.custom';

function readCachedCustomTheme(): CustomTheme | null {
  try {
    const raw = localStorage.getItem(CUSTOM_THEME_CACHE_KEY);
    return raw ? (JSON.parse(raw) as CustomTheme) : null;
  } catch {
    return null;
  }
}

export function cachedThemeColors(mode: PaletteMode): ThemeColors {
  return resolveThemeColors(mode, localStorage.getItem(ACCENT_CACHE_KEY) ?? 'navy', readCachedCustomTheme());
}

export function cacheThemeColors(accentColor: string, customTheme: CustomTheme | null): void {
  localStorage.setItem(ACCENT_CACHE_KEY, accentColor);
  if (customTheme) {
    localStorage.setItem(CUSTOM_THEME_CACHE_KEY, JSON.stringify(customTheme));
  } else {
    localStorage.removeItem(CUSTOM_THEME_CACHE_KEY);
  }
}
